import { createFileRoute } from '@tanstack/react-router';

import { PageShell } from '@/components/app/page-shell';
import { MemoriesList } from '@/features/assistant';

/**
 * `/dashboard/settings/claire-memories` — what Claire remembers about the
 * business. Same `MemoriesList` as the old deep-linked
 * `/settings/claire/memories` page, surfaced in the main settings navigation
 * under Organisation, next to Claire WhatsApp.
 */
export const Route = createFileRoute(
  '/_authed/dashboard/settings/claire-memories'
)({
  component: ClaireMemoriesSettingsPage,
});

function ClaireMemoriesSettingsPage() {
  return (
    <PageShell className="pt-10 pb-8" maxWidth="max-w-[960px]">
      <title>Claire memories | Borrah</title>

      <header className="space-y-1">
        <h2 className="font-semibold text-xl tracking-tight">
          Claire&apos;s memories
        </h2>
        <p className="text-muted-foreground text-sm">
          Things Claire remembers about you and your business. She uses these in
          conversations and in everything she writes for you. Anything you tie
          to a date &mdash; &ldquo;we&rsquo;re booked out until the 10th&rdquo;
          &mdash; drops off this list by itself once the date passes.
        </p>
      </header>

      <MemoriesList />
    </PageShell>
  );
}
